module.exports = __webpack_public_path__ + "img/交易台1.b7ae6314.png";